import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone'
})
export class TelefonePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value != null){
      value = value.toString();
      
      if(value.length == 10){
        return '(' + value.slice(0,2) + ') ' + value.slice(2,6) + '-' + value.slice(6, 10);
      }
      else if(value.length == 11){
        return '(' + value.slice(0,2) + ') ' + value.slice(2,7) + '-' + value.slice(7, 11);
      }
    }
    else{
      return value;
    }
  }

}
